import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { ReactNode } from "react";

import {
  ICON_COL_WIDTH,
  ITEM_HEIGHT,
  TEXT_WIDTH,
} from "../../config/sidebar.constants";

interface SidebarItemProps {
  icon: ReactNode;
  label?: string;
  expanded: boolean;
  onClick?: () => void;
  tooltip?: string;
  children?: ReactNode;
  active?: boolean;
}

const SidebarItem = ({
  icon,
  label,
  expanded,
  onClick,
  tooltip,
  children,
  active = false,
}: SidebarItemProps) => {
  const tooltipText = tooltip ?? (expanded ? "" : (label ?? ""));

  return (
    <ListItem
      disablePadding
      divider
      sx={{
        "&.MuiListItem-divider": {
          borderBottomColor: "rgba(255,255,255,0.1)",
        },
        "&:hover": {
          backgroundColor: "sidebar.light",
        },
        ...(active && {
          backgroundColor: "sidebar.light",
        }),
      }}
    >
      <Tooltip title={tooltipText}>
        <ListItemButton
          onClick={onClick}
          sx={{
            height: ITEM_HEIGHT,
            p: 0,
            overflow: "hidden",
            "&:hover": { backgroundColor: "transparent" },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              justifyContent: "center",
              color: "inherit",
              width: ICON_COL_WIDTH,
              flexShrink: 0,
            }}
          >
            {icon}
          </ListItemIcon>

          {label && (
            <ListItemText
              primary={label}
              sx={{
                flexShrink: 0,
                opacity: expanded ? 1 : 0,
                transition: (theme) =>
                  theme.transitions.create(["opacity"], {
                    duration: theme.transitions.duration.shorter,
                  }),
              }}
              slotProps={{
                primary: {
                  color: "sidebar.contrastText",
                  fontSize: 13,
                  maxWidth: TEXT_WIDTH,
                },
              }}
            />
          )}

          {children}
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
};

export default SidebarItem;
